import { render, staticRenderFns } from "./category-title.vue?vue&type=template&id=e00f861a&scoped=true&"
import script from "./category-title.vue?vue&type=script&lang=js&"
export * from "./category-title.vue?vue&type=script&lang=js&"
import style0 from "./category-title.vue?vue&type=style&index=0&id=e00f861a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e00f861a",
  null
  
)

export default component.exports